<div class="player-list">
  <bcu-local-spinner [size]="40" [visible]="(players$ | async).loading" *ngIf="(players$ | async).loading">
  </bcu-local-spinner>
  <div [ngClass]="{'bay-club-light-blue-2-bg': even}"
    *ngFor="let player of (players$ | async).items;  let even = even; let odd = odd ">
    <app-player-list-item [player]="player" [selectedPlayer]="(selectedPlayer$ | async)" (playerSelected)="onPlayerSelected($event)"></app-player-list-item>
  </div>
</div>
